/**
 * Internal dependencies
 */
import type { SegmentId } from '@nab/types';
import type { State } from './types';

export const INIT_STATE: State = {
	editor: {
		activeGoalId: '',
		activeSegmentId: '' as SegmentId,
		aiAlternativeModal: undefined,
		alternativePreviewerUrl: '',
		draftStatusRationale: '',
		hasExperimentBeenRecentlySaved: false,
		isExperimentBeingSaved: false,
		reusableDialog: undefined,
	},

	experiment: {
		alternatives: {
			byId: {
				control: {
					id: 'control',
					attributes: {},
					links: { edit: '', heatmap: '', preview: '' },
				},
			},
			allIds: [],
		},

		conversionActions: {},

		data: {
			id: 0,
			type: '',
			status: 'draft',
			name: '',
			description: '',
			startDate: '',
			endDate: '',
			endMode: 'manual',
			endValue: 0,
			autoAlternativeApplication: false,
			isTestedElementInvalid: false,
			links: {
				edit: '',
				preview: '',
			},
		},

		goals: {},

		scope: {},

		segmentation: {
			evaluation: 'tested-page',
			rules: {},
			segments: {},
		},
	},
};
